/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var IS_SAFARI;
var _default = function _default() {
  if (IS_SAFARI !== undefined) {
    return IS_SAFARI;
  }
  var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
  return IS_SAFARI = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
};
exports.default = _default;